import { createSlice } from '@reduxjs/toolkit';

// Load MgCd, EmpNo, and token from localStorage for persistence
const initialState = {
  mode: 'dark',
  MgCd: localStorage.getItem('MgCd') ?? null,
  EmpNo: localStorage.getItem('EmpNo') ?? null,
  isAuthenticated: Boolean(localStorage.getItem('token')),
  username: localStorage.getItem('username'),
};

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setMode: (state) => {
      state.mode = state.mode === 'light' ? 'dark' : 'light';
    },
    login: (state, action) => {
      console.log("Login payload:", action.payload); // Debugging output
      state.isAuthenticated = true;
      state.MgCd = action.payload.MgCd || null;
      state.EmpNo = action.payload.EmpNo || null;
      localStorage.setItem('token', action.payload.token);
      localStorage.setItem('MgCd', action.payload.MgCd || '');
      localStorage.setItem('EmpNo', action.payload.EmpNo || '');
      localStorage.setItem('username', action.payload.username || '');
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.MgCd = null;
      state.EmpNo = null;
      localStorage.removeItem('token');
      localStorage.removeItem('MgCd');
      localStorage.removeItem('EmpNo');
      localStorage.removeItem('username');
    },
    setMgCd: (state, action) => {
      console.log("Setting MgCd:", action.payload);
      state.MgCd = action.payload || null;
      localStorage.setItem('MgCd', action.payload || '');
    },
    setEmpNo: (state, action) => {
      console.log("Setting EmpNo:", action.payload);
      state.EmpNo = action.payload || null;
      localStorage.setItem('EmpNo', action.payload || '');
    },
    setUsername: (state, action) => {
      console.log("Setting username:", action.payload);
      state.username = action.payload || null;
      localStorage.setItem('username', action.payload || '');
    },
  },
});

// Export actions and reducer
export const { setMode, login, logout, setMgCd, setEmpNo, setUsername } = globalSlice.actions;
export default globalSlice.reducer;
